import { Link } from 'react-router-dom';


const StudyLink = (props) => {
  const client = localStorage.getItem('client')

  return (
    <Link to={`/${client}/ctg-studies/` + props.data?.ctg_data?.nct_id}>{props.data?.ctg_data?.org_study_id}</Link>
  );
};

export default StudyLink;
